<template>
  <div id="app">
  <router-view class="router-view"/>
</div>
</template>

<script>
import {Config, Labels, DataLayer, Utils, State, Monitoring} from "./services";

export default {
  name: 'App',
  components: {
    
  },
  created() {
    Config.init();
    Labels.init();
  },
  mounted() {
    Monitoring.startActivity("List of countries load");
    let loader = Utils.showLoader("#app");
    DataLayer.getCountries().then(countries => {
      State.set("countries", countries);
    }).catch(err => {
      Utils.showStatusMessage(`Could not load country list! ${err}.`,"red",5000);
    }).finally(() => {
      Utils.removeLoader(loader);
      Monitoring.endActivity("List of countries load");
    });
  }
}
</script>


<style lang="scss">
#app {
  font-family: "Gotham SSm A", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  position: relative;
}

.cla-messagebox {
  position: fixed;
  top: 100px;
  right: 0;
  background-color: #ffffff;
  max-width: 400px;
  padding: 20px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  box-shadow: 3px 3px rgba(200, 200, 200, 0.4);
  border-left: 1px solid #e4e4e4;
  animation: slide 0.5s forwards;
  transition: opacity 500ms linear;
  opacity: 1;
  z-index: 10001;
}

@keyframes slide {
  0% {
    right: 0;
  }
  100% {
    right: 100px;
  }
}

.cla-messagebox.green {
  border-top: 3px solid green;
}

.cla-messagebox.yellow {
  border-top: 3px solid yellow;
}

.cla-messagebox.red {
  border-top: 3px solid red;
}

.loader {
  width: 64px;
  height: 64px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg class='lds-spinner' width='64px' height='64px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' style='background: none;'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9166666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(30 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8333333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(60 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.75s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(90 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(120 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5833333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(150 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(180 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4166666666666667s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(210 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.3333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(240 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.25s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(270 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.16666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(300 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.08333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(330 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
  margin: auto;
}

.loader.top {
  top: 80px;
  bottom: unset;
}

.spacer {
  flex-grow: 1;
}

.page-header {
  margin-bottom: 40px;
}

/* icons */
a.vector-icon {
  display: block;
  font-weight: 500;
  padding-left: 25px;
  cursor: pointer;
  background-position: 0 50%;
  background-repeat: no-repeat;

}

a.map-link {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 365 560' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%232655FF' d='M182.9,551.7c0,0.1,0.2,0.3,0.2,0.3S358.3,283,358.3,194.6c0-130.1-88.8-186.7-175.4-186.9 C96.3,7.9,7.5,64.5,7.5,194.6c0,88.4,175.3,357.4,175.3,357.4S182.9,551.7,182.9,551.7z M122.2,187.2c0-33.6,27.2-60.8,60.8-60.8 c33.6,0,60.8,27.2,60.8,60.8S216.5,248,182.9,248C149.4,248,122.2,220.8,122.2,187.2z'/%3E%3C/g%3E%3C/svg%3E");
}

a.globe-link {
  background-image: url("data:image/svg+xml,%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='1000px' height='1000px' viewBox='0 0 1000 1000' enable-background='new 0 0 1000 1000' xml:space='preserve'%3E%3Cpath fill='%232655FF' d='M560.95,1000c-1.17,0-3.978-1.177-5.147-2.587c35.213-23.753,68.203-51.385,98.152-84.311 c38.138-42.216,68.203-88.194,91.951-136.995h172.789c-18.133,28.928-40.594,55.268-64.109,80.313 C774.684,936.855,671.151,986.948,560.95,1000 M934.605,524.34H1000c-2.574,69.967-20.824,137.114-51.006,198.967H769.42 c23.631-63.264,36.617-130.41,39.307-198.967h73.468 M882.195,473.073h-73.468c-3.978-69.852-18.484-139.583-44.572-205.671h52.41 h51.24h77.328c32.639,63.382,51.006,133.116,54.867,205.671h-65.395 M816.565,216.135h-75.924 c-22.461-44.804-51.24-88.312-85.283-126.531c-30.182-32.926-64.342-60.676-99.555-84.311c1.17-1.414,2.574-1.414,2.574-1.414 L556.972,0C669.747,13.052,773.28,63.145,854.586,143.581c22.344,22.458,42.115,46.096,58.961,72.555h-45.742 M703.79,267.402 c28.896,64.678,44.572,134.408,48.549,204.257H519.069V267.402H703.79z M677.702,214.721H519.069V47.388 c34.043,22.343,65.629,48.683,94.408,80.435C638.395,155.455,659.219,184.383,677.702,214.721 M568.905,723.307h-51.24V525.754 h233.388c-2.691,67.143-17.08,134.29-43.285,197.553h-86.57 M621.198,776.106h61.652c-19.537,34.336-43.285,67.261-70.777,97.481 c-28.896,31.634-60.365,59.384-94.408,81.609v-179.09h51.24 M314.459,216.135c17.197-30.342,39.307-60.68,62.939-87.02 c27.609-30.22,56.504-55.383,89.261-76.434v163.454H314.459z M307.908,776.106h158.751v175.329 c-32.756-21.166-61.652-47.506-89.261-77.848C350.023,844.663,327.562,810.442,307.908,776.106 M323.701,473.073h-85.049 c3.861-69.852,19.654-139.583,48.433-204.257h179.574v204.257h-90.547 M376.111,525.754h90.547v197.553H281.82 c-26.322-61.853-40.711-130.41-43.168-197.553h85.049 M431.095,1.292v1.295c0,1.292,1.521,1.292,2.808,1.292 c-35.33,23.638-68.086,52.799-98.269,85.725c-35.564,38.219-64.342,80.317-86.57,125.117H86.453 c18.367-25.045,38.02-48.683,59.078-71.141C224.146,64.559,323.701,15.758,431.095,1.292 M145.531,856.419 c-24.918-25.045-45.976-52.681-64.226-81.724h161.207c24.918,50.212,55.1,96.189,93.121,137.11 c30.182,32.926,62.939,61.853,98.269,85.606c-1.287,0-2.808,1.41-2.808,1.41C323.701,984.361,224.146,935.441,145.531,856.419 M58.961,471.659H0c3.978-71.141,23.631-140.875,54.984-204.257h170.449c-26.088,66.088-40.594,134.408-44.689,204.257h-70.777 M109.967,524.34h70.777c2.808,68.557,15.793,135.703,39.307,198.967H51.123C20.941,661.454,3.978,594.307,0,524.34h58.961'/%3E%3C/svg%3E");
  background-size: 20px;
}

a.doc-link {
  background-image: url("data:image/svg+xml,%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 600 600' enable-background='new 0 0 600 600' xml:space='preserve'%3E%3Crect display='none' fill='%23020202' stroke='%23000000' stroke-width='1.1344' stroke-miterlimit='10' width='600' height='600'/%3E%3Cg%3E%3Cg%3E%3Cpath fill='%232655FF' d='M449.2,197.8h-99.8V44.5c0-14-11.2-25.5-25-25.5h-49.9c-13.7,0-25,11.5-25,25.5v153.3h-99.8l149.7,204.4 L449.2,197.8z M561.6,274.5c-20.7,0-37.4,17.2-37.4,38.3v191.6H74.9V312.8c0-21.2-16.8-38.3-37.4-38.3C16.8,274.5,0,291.6,0,312.8 v229.9C0,563.8,16.8,581,37.4,581h524.1c20.7,0,37.4-17.2,37.4-38.3V312.8C599,291.6,582.2,274.5,561.6,274.5z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: 18px;
}

a.web-link {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath fill='%232655FF' d='M18 2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM4 3.5A1.5 1.5 0 1 1 2.5 5 1.5 1.5 0 0 1 4 3.5zM18 16H2V8h16z'/%3E%3C/svg%3E");
}
</style>
